<template>
    <div>
        <p>spoiler</p>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    
</style>